import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigServices } from '../../core/config';
import { ServicesService } from '../services.service';

@Injectable({
  providedIn: 'root'
})
export class DisabilityTypesService extends ServicesService {

  constructor(public http: HttpClient, public configService: ConfigServices) {
    super('disability-types', http, configService);
  }
}
